import Vue from 'vue'
import Vuex from 'vuex'
import auth from './views/auth/store'
import audience from './views/audience/store'
import backOffice from './views/backOffice/store'
import balance from './views/balance/store'
import senders from './views/senders/store'
import campaign from './views/campaign/store'
import automation from './views/automation/store'
import htmlBuilder from './views/htmlBuilder/stores/htmlBuilder'
import whitelabel from './views/whitelabel/store'
import { getItem } from './utils/StorageManager'

Vue.use(Vuex)

let lang = getItem('lang') // Verifica a língua padrão do utilizador

const state = {
  asideShow: false,
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  asideBarShow: 'responsive',
  asideBarMinimize: false,
  darkMode: false,
  toastMessage: [],
  showBaseMenu: true,
  showUserControl: true,
  overview: 0,
  lang: lang || 'en-US',
}

const mutations = {
  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set(state, [variable, value]) {
    state[variable] = value
  },
  toggle(state, variable) {
    state[variable] = !state[variable]
  },

  setToastMessage(state, item) {
    state.toastMessage = []
    if (item) {
      state.toastMessage.push(item)
      return
    }
    state.toastMessage = []
  },

  UPDATE_OVERVIEW(state, value) {
    state.overview = value
  },

  SHOW_BASE_MENU(state) {
    state.showBaseMenu = true
  },

  HIDE_BASE_MENU(state, veiodeonde) {
    state.showBaseMenu = false
  },

  SHOW_BASE_USER_CONTROLS() {
    state.showUserControl = true
  },

  HIDE_BASE_USER_CONTROLS() {
    state.showUserControl = false
  },

  UPDATE_LANG(state, value) {
    state.lang = value
  },

  SET_NOTIFICATION_LOOP(state, interval) {
    if (state.notificationInterval) {
      clearInterval(state.notificationInterval)
    }
    state.notificationInterval = interval
  },

  CLOSE_NOTIFICATION_LOOP(state) {
    if (state.notificationInterval) {
      clearInterval(state.notificationInterval)
    }
  },
}

const getters = {
  getLang: (state) => state.lang,
}

export default new Vuex.Store({
  strict: true,
  state,
  mutations,
  getters,
  modules: {
    auth,
    audience,
    senders,
    campaign,
    backOffice,
    balance,
    automation,
    htmlBuilder,
    whitelabel,
  },
})
